// Textos del listado de la promo por viajes (trip-promos). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'es',
  data: {
    TRIP_PROMOS: {
      BREADCRUMB_ARIA: 'Ruta de navegación',
      BREADCRUMB_MARKETING: 'Marketing',
      BREADCRUMB_PROMO: 'Promo viajes',
      TITLE: 'Promo por viajes',
      DESCRIPTION:
        "Usuarios a los que se ha activado la promo por viajes. Al completar los viajes verificados de más de 10 km que se pidieron (a PVP o a coste 0, como conductor, como pasajero o ambos) se les ingresa el importe en la wallet automáticamente. No tiene consecuencias de fraude.",
      SEARCH_PLACEHOLDER: 'Buscar nombre, email o teléfono…',
      SEARCH_ARIA: 'Buscar usuario',
      STATUS_ARIA: 'Estado',
      STATUS_ALL: 'Estado: todos',
      STATUS_ACTIVE: 'En curso',
      STATUS_COMPLETED: 'Completada',
      STATUS_CANCELLED: 'Cancelada',
      FILTER_COMPLETED: 'Completadas',
      FILTER_CANCELLED: 'Canceladas',
      CLEAR_FILTERS: 'Limpiar filtros',
      ACTIVATE: 'Activar promo',
      LOADING: 'Cargando promociones…',
      RETRY: 'Reintentar',
      EMPTY_FILTERED: 'Ninguna promoción coincide con la búsqueda.',
      EMPTY:
        'Todavía no se ha activado ninguna promoción. Actívala con «Activar promo» o desde la ficha del usuario.',
      TH_USER: 'Usuario',
      TH_AMOUNT: 'Importe',
      TH_ACTIVATED_BY: 'Activada por',
      TH_DATE: 'Fecha',
      TH_PROGRESS: 'Progreso',
      TYPE_ARIA: 'Tipo de viaje',
      TYPE_ALL: 'Tipo: todos',
      TYPE_PVP: 'A PVP',
      TYPE_WITHOUT_COST: 'A coste 0',
      TYPE_ANY: 'Cualquiera',
      ROLE_ANY: 'Conductor o pasajero',
      ROLE_DRIVER: 'Solo conductor',
      ROLE_RIDER: 'Solo pasajero',
      TH_TYPE: 'Tipo',
      TH_STATUS: 'Estado',
      OPEN: 'Abrir',
      PROGRESS_TITLE: '{{done}} de {{required}} viajes',
      DEPOSITED_ON: 'Ingresada el {{date}}',
      CANCELLED_BY: 'Cancelada por {{name}} el {{date}}',
      VIEW_PROFILE: 'Ver ficha',
      SHOWING: 'Mostrando',
      OF: 'de',
      PROMOS: 'promociones',
      PER_PAGE_LABEL: 'Promociones por página',
      PER_PAGE_OPTION: '{{n}} por página',
      PREV_PAGE: 'Página anterior',
      NEXT_PAGE: 'Página siguiente',
      PREV: 'Anterior',
      NEXT: 'Siguiente',
      ERROR_FORBIDDEN: 'No tienes permiso para ver este listado.',
      ERROR_LOAD: 'No se ha podido cargar el listado.',
    },
  },
};
